const getShippingInfo = (order) => {
  let info = ((order.country || '') + (order?.state || '') + ' ' + (order?.city || '') + ' ' + (order.street || '') + ' ' + (order?.apartment || ''));
  if (order?.zipCode !== undefined) {
    info += ' ' + order?.zipCode;
  } else if (order?.zip_code !== undefined) {
    info += ' ' + order?.zip_code;
  }
  return info;
};
const getInsuranceTax = (order) => {
  if (order?.insuranceFee !== undefined) {
    return order?.insuranceTax;
  } else {
    return order?.insurance_tax;
  }
};
const getInsuranceFee = (order) => {
  if (order?.insuranceFee !== undefined) {
    return order?.insuranceFee;
  } else {
    return order?.insurance_fee;
  }
};
const getShippingMemberName = (order) => {
  return (order?.firstName || order?.first_name || '') + ' ' + (order?.lastName || order?.last_name || '');
};
export default {
  getShippingInfo,
  getInsuranceTax,
  getInsuranceFee,
  getShippingMemberName
};
